import React from "react";
import { Row, Col } from "react-bootstrap";
var NewMandateData = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: props.parentClassName },
                React.createElement("div", { className: "bankaccountsection" },
                    React.createElement("div", { className: "mandateleftsection" },
                        React.createElement("div", { className: "DMSansNormal_12_400  txt_secondary-gray" }, "Mandate ID"),
                        React.createElement("div", { className: "RobotoM_14_700 txt_blackOne1 mb-2" }, props.MandateID),
                        React.createElement("div", { className: "DMSansNormal_12_400  txt_secondary-gray" }, "Date"),
                        React.createElement("div", { className: "DMSan_14_700 txt_blackOne1 mb-2" }, props.mandateDate),
                        React.createElement("div", { className: "DMSansNormal_12_400  txt_secondary-gray" }, "Status"),
                        React.createElement("div", { className: "DMSan_14_700 txt_blackOne1 mb-2" }, props.status)),
                    React.createElement("div", { className: "mandaterightsection" },
                        React.createElement("div", { className: "mandateleftsection" },
                            React.createElement("div", { className: "DMSansNormal_12_400 txt_secondary-gray" }, "Amount"),
                            React.createElement("div", { className: "RobotoM_14_700 txt_blackOne1 mb-2" }, props.mandateAmount),
                            React.createElement("div", { className: "DMSansNormal_12_400  txt_secondary-gray " }, "Bank Name"),
                            React.createElement("div", { className: "DMSan_14_700 txt_blackOne1 mb-2" }, props.BankName))))))));
};
export default NewMandateData;
